var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_373_5836)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50.0005,
    rx: 25,
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 27.4995C29.142 27.4995 32.4998 24.1416 32.4998 19.9995C32.4998 15.8574 29.142 12.4995 24.9999 12.4995C20.8578 12.4995 17.4999 15.8574 17.4999 19.9995C17.4999 24.1416 20.8578 27.4995 24.9999 27.4995Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66293 43.7334C8.17572 45.0034 8.61087 46.427 9.68549 47.261C13.9163 50.5446 19.23 52.4995 25.0002 52.4995C30.7762 52.4995 36.0948 50.5406 40.3278 47.2509C41.4018 46.4162 41.8361 44.9924 41.348 43.7226C38.8249 37.1584 32.4603 32.4995 25.0075 32.4995C17.5507 32.4995 11.1832 37.1634 8.66293 43.7334Z",
    fill: "#E5E7EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_5836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50.0005,
    rx: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.3ad03fcc15d5147855920f93e5c78585.svg";
export { ForwardRef as ReactComponent };